<template>
	<div style="font-family: -apple-system-font ,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
		<div class="carousel">
			案例精选
		</div>
		<div class="case_main">
			<div class="case_top">
				<div class="case_title">赤峰智能收运系统</div>
				<div class="case_time">
					<img src="../../assets/images/developerCommunity/dev_time.png" alt="">
					<span>2020/06/12</span>
				</div>
				<hr>
			</div>
			<div class="case_detail">
				<div class="model">
					<div class="model_title">【企业介绍】</div>
					<div class="section">
						内蒙古青格尔环保科技有限公司成立于2016年，同年10月29日中标承建赤峰市餐厨废弃物资源化利用和无害化处理（PPP）项目，并负责项目的建设工作和后续21年的特许运营。2018年引入资质更优的睿恒金奥（北京）集团有限公司，成立关联公司—内蒙古桐格麓科环境卫生管理服务有限公司，继续组织项目建设。项目的服务对象为“三区一旗”，包括赤峰市红山区、松山区（含新城）、元宝山区（平庄镇和建昌营镇）和喀喇沁旗（锦山镇、牛营子镇）。
					</div>
				</div>
				<div class="model">
					<div class="model_title">【项目概况】</div>
					<div class="section">
						赤峰餐厨废弃物资源化项目是国家第三批试点项目，同时也是国务院重点督办的项目。日处理量110t，覆盖产生单位3000家，拥有餐厨垃圾收运车12辆，集收运与处理于一体，作为赤峰项目稳定运行管控的重要手段和平台工具，赤峰餐厨项目智能收运系统为项目的收运运营实施奠定坚实基础。
					</div>
					<div class="section">
						<img src="../../assets/images/detail_pic2.png" alt="">
					</div>
					<div class="section">
						智能收运系统是一种新型、绿色、智能、高效、高端的垃圾收运方式，结合垃圾分类、收运、处理等智能化管理系统，实现垃圾从产生到消失的全产业链处置管控。
					</div>
					<div class="section">
						餐厨垃圾智能化收运，严查提炼地沟油源头，推进餐厨垃圾无害化处理。为每个餐厨垃圾桶量身定制“身份证”，在垃圾桶外侧加装智能芯片，实现全线上签约，记录收运点的地理位置、餐厨垃圾产生单位等信息，实现餐厨垃圾管理的信息化。通过垃圾桶芯片和餐厨垃圾车上传感器的对接以及数据读取，可确定当日该餐饮商户垃圾是否收运，同时，也可以防止商户餐厨垃圾的处置去向不明，有利于切断地沟油回收的黑色利益链，从源头有效监管和规范了餐厨垃圾收运流程。通过大数据算法模型，预测产生单位每日垃圾产生量，自动计算收运最短路径，生成收运计划，下发收运人员APP。同时餐厨垃圾收运车上加装了自动读卡、称重、车载打印机、视频监控及GPS系统，车载智能管理设备自动识别，匹配专用垃圾桶的信息（如单位名称、收运地址等），自动对餐厨垃圾重量进行称重并上传数据，分类汇总、生成报表。监管平台可全程监控车辆的作业情况，对收运作业过程中是否按时收运、是否按路线收运、收运过程是否规范等也作了全流程管控，大大提高了收运效率。
					</div>
				</div>
				<div class="model">
					<div class="model_title">【项目效果】</div>
					<div class="section">
						实现全线上签约，提高签约效率88.8%。
					</div>
					<div class="section">
						降低收运车辆行驶路程27%，费用降低18.21万/年，增效9.48%。
					</div>
					<div class="section">
						提高装运效率33.3%。
					</div>
					<div class="section">
						提高驾驶安全系数至90%以上，作业规范率95%以上。
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: 'CaseCfznsyDetail',
		data() {
			return {
				detailId: this.$route.params.id,
			}
		},
		mounted() {
			window.scrollTo(0, 0)
			this.init()
		},
		methods: {
			init() {
				console.log(this.detailId)
			}
		}
	}
</script>

<style lang="scss">

.carousel {
		background-color: #1a1a1a;
		height: 4rem;
		text-align: center;
		line-height: 4rem;
		font-size: 0.4rem;
		color: #FFFFFF;
	}

	.case_main {

		padding: 0 2.4rem;
		margin-bottom: 0.3rem;

		.case_top {
			margin-top: 0.6rem;

			.case_title {
				font-size: 0.32rem;
			}

			.case_time {
				margin-top: 0.2rem;
				font-size: 0.18rem;
				color: #999999;
				display: flex;
				align-items: center;
				img {
					width: 0.2rem;
					height: 0.2rem;
					margin-right: 0.1rem;
				}
			}

			hr {
				margin-top: 0.4rem;
				color: #cccccc;
			}
		}

		.case_detail {
			margin: 0 2.2rem;
			margin-bottom: 0.6rem;
			color: #000000;
			img {
				width: 100%;
			}
			.model{
				margin-top: 0.2rem;
				.model_title{
					font-size: 0.22rem;
					font-weight: 600;
				}
				.section{
					padding-left: 0.12rem;
					text-indent: 2em;
					line-height: 0.36rem;
					font-size: 0.18rem;
					margin-top: 0.12rem;
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/detail_page/CaseCfznsyDetail.vue